// Block content, read-only, in the style of the cards on the Schedule tab: the description, the
// exercises in the shared ExerciseTable, and one line per target with its note under it. The
// block library cards, the hover details of the block picker and the toolbar popover, the library
// drag preview, and the read-only block dialog use it.
import { Fragment } from "react";
import type { ReactNode } from "react";
import { Typography } from "antd";
import { ExerciseTable } from "./ExerciseTable";
import type { RtpBlockContent } from "./types";

interface BlockContentViewProps {
	content: RtpBlockContent;
	metricLabel: (key: string) => string;
	// Shown inline at the start of the description, or alone in its own row when there is none.
	lead?: ReactNode;
	// Pass through to ExerciseTable: a long list collapses behind a "+N more" link.
	collapsible?: boolean;
	// Pass through to ExerciseTable: the size of the Schedule cards.
	compact?: boolean;
}

export const BlockContentView = ({
	content,
	metricLabel,
	lead,
	collapsible = false,
	compact = false,
}: BlockContentViewProps) => {
	const { description, exercises, targets } = content;
	return (
		<div className="rtp-bcv">
			{description.trim() ? (
				<Typography.Paragraph className="rtp-block-text">
					{lead}
					{description}
				</Typography.Paragraph>
			) : lead ? (
				<div className="rtp-block-lead">{lead}</div>
			) : null}
			{exercises.length > 0 ? (
				<ExerciseTable exercises={exercises} collapsible={collapsible} compact={compact} />
			) : null}
			{targets.map((t, i) => (
				<Fragment key={`${t.metricKey}-${i}`}>
					<div className="rtp-block-line">
						<span className="rtp-block-line-name">{metricLabel(t.metricKey)}</span>
						<span className="rtp-block-line-value">{t.target || "—"}</span>
					</div>
					{t.note ? <div className="rtp-block-line-note">{t.note}</div> : null}
				</Fragment>
			))}
		</div>
	);
};
